module.exports = __webpack_public_path__ + "static/media/logoTetrice.aa32da7b.png";